import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export const DisplayTextWrapper = styled(Text)(({ theme, color }) => {
    return {
        position: "relative",

        "::before": {
            content: "''",
            position: "absolute",
            bottom: theme.spacing.xxxSmall,
            left: "0",
            right: "0",
            borderTop: `1px dashed ${theme.colors[theme.colorMode][color as keyof IColors]}`,
        },
    };
});

export const TitleWrapper = styled(Text)(({ theme }) => {
    return {
        marginBottom: theme.spacing.xxSmall,
    };
});
